var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.747,
    height: 26.092,
    viewBox: "0 0 27.747 26.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 1,
    x2: 0.084,
    y2: 0.119,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "handshake",
    transform: "translate(0 -13.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M25.419,16.279a8,8,0,0,0-11.547.287A7.969,7.969,0,1,0,2.531,27.744,2.793,2.793,0,0,0,4.1,32.513a2.8,2.8,0,0,0,2.772,2.975,2.791,2.791,0,0,0,3.486,2.5,2.794,2.794,0,0,0,4.661,1.244c.852-.847,1.53-1.382,1.573-2.665a2.8,2.8,0,0,0,2.649-2.682A2.8,2.8,0,0,0,21.924,31.2a2.8,2.8,0,0,0,2.686-2.857l.809-.809A7.971,7.971,0,0,0,25.419,16.279ZM3.751,29.039l.76-.76A1.008,1.008,0,0,1,5.936,29.7l-.76.76A1.008,1.008,0,0,1,3.751,29.039ZM5.871,32.7a1,1,0,0,1,.3-.713l.761-.76a1.008,1.008,0,0,1,1.424,1.425l-.671.671a1.056,1.056,0,0,1-.8.385A1.012,1.012,0,0,1,5.871,32.7Zm3.067,3.306a1.012,1.012,0,0,1,0-1.425l.671-.671a1.021,1.021,0,0,1,1.514-.089,1.009,1.009,0,0,1,0,1.425l-.76.76A1.008,1.008,0,0,1,8.938,36.009Zm5.583,1.207-.76.76a1.008,1.008,0,0,1-1.425,0,1.012,1.012,0,0,1,0-1.425l.76-.76a1.008,1.008,0,1,1,1.425,1.425Zm8.015-8.082a1.012,1.012,0,0,1-1.425,0l-3.959-3.959L15.9,26.433l3.959,3.959a1.008,1.008,0,0,1-1.425,1.425l-3.892-3.892-.067-.067-1.258,1.258.067.067,3.892,3.892A1.008,1.008,0,1,1,15.746,34.5h0a2.788,2.788,0,0,0-2.645-.69,2.8,2.8,0,0,0-2.683-2.059A2.8,2.8,0,0,0,8,29.182,2.793,2.793,0,0,0,3.864,26.56a6.195,6.195,0,1,1,8.751-8.736l-2.2,2.2,1.762,1.762a4.033,4.033,0,0,0,4.995.559l5.364,5.364a1.009,1.009,0,0,1,0,1.425Zm1.625-2.854-.271.271q-.046-.051-.1-.1L17.242,19.9l-.629.629a2.25,2.25,0,0,1-3.178,0l-.5-.5,2.487-2.487a6.183,6.183,0,0,1,8.743,8.743Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipHandshake);
export default __webpack_public_path__ + "static/media/clip-handshake.581c05965afabd51f95eda67c1a3ac66.svg";
export { ForwardRef as ReactComponent };